import { render, staticRenderFns } from "./WalletView.vue?vue&type=template&id=6fb5ddf1&"
import script from "./WalletView.vue?vue&type=script&lang=ts&"
export * from "./WalletView.vue?vue&type=script&lang=ts&"
import style0 from "./WalletView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports